import React, {useState, useEffect} from 'react';
import { hashCode } from '../../Services/helpers';

const marked = import(/* webpackChunkName: "marked" */'marked');

const Markdown = ({markdown, className, btnCallback}) => {
    const [html, setHtml] = useState(null);
    const [hash, setHash] = useState(null);
    const [buttons, setButtons] = useState(null);

    useEffect(() => {
        marked.then(marked => {
            // Convert array options to buttons
            let replaced = markdown.trim().replace(
                /\[((?:"[^"]+",?\s*)+)\]/,
                (match, options) => {
                    const buttons = JSON.parse(`[${options}]`);
                    setButtons(buttons);
                    return '';
                }
            );
            replaced = marked.parse(replaced);

            // Remove the 【1†a】 type references
            replaced = replaced.replace(
                /【[0-9.:]+†(docs-)?(?<key>[a-zA-Z]+)(\.md)?】/g,
                (match, docs, key) => {
                    if (docs !== 'docs-') {
                        return '';
                    }
                    const path = key.replace(/([A-Z])/g, (m, u) => `-${u.toLowerCase()}`).trim('-');
                    return ` &nbsp; <a href="https://getsoapy.com/docs/${path})" target="_blank">Docs 📄</a>`;
            });

            setHtml(replaced);
        });
        setHash(hashCode(markdown));
    }, [markdown]);

    return <>
        <div className={className}
            dangerouslySetInnerHTML={{__html: html, markdown: hash}}
            markdown={hash}
        />
        {(buttons && btnCallback) && <div className="flex gap-3 justify-center mt-2">
            {buttons.map(button => {
                return <button className="btn btn-sm bg-white border px-3"
                    onClick={() => btnCallback(button)}
                >
                    {button}
                </button>
            })}
        </div>}
    </>;
}

export default Markdown;
